import { CreatePlant, SearchPlant, UpdatePlant } from '@/types/plant'
import { queryStringify } from '@/ultils'
import axiosClient from '../axiosClient'

const plantDataConfigApi = {
  getAll(searchParams: SearchPlant) {
    const url = '/api/plant'
    return axiosClient.get(url + queryStringify(searchParams))
  },

  getById(interfaceId: string, id: string) {
    const url = `/api/plant/${interfaceId}/${id}`
    return axiosClient.get(url)
  },

  create(payload: CreatePlant) {
    const url = '/api/plant'
    return axiosClient.post(url, payload)
  },
  delete(interfaceId: string, id: string) {
    const url = `/api/plant/?interfaceId=${interfaceId}&id=${id}`
    return axiosClient.delete(url)
  },
  update(payload: UpdatePlant) {
    const url = '/api/plant'
    return axiosClient.put(url, payload)
  },
}

export default plantDataConfigApi
